

// Sauvegarder le fetch original
const originalFetch = window.fetch;

// Type pour les arguments de fetch
type FetchArgs = Parameters<typeof fetch>;

// Remplacer fetch globalement
window.fetch = function(...args: FetchArgs): Promise<Response> {
  const [resource, options = {}] = args;
  
  // Obtenir l'URL sous forme de string
  const url = typeof resource === 'string' 
    ? resource 
    : resource instanceof URL 
    ? resource.href 
    : resource.url;
  
  // Vérifier si c'est une requête GET d'image individuelle
  const isIndividualImage = url.match(/\.(jpg|jpeg|png|gif|webp|svg|bmp|ico)$/i) ||
                            (url.match(/\/images\/\d+$/) && options.method === 'GET');

  // Vérifier si c'est une requête GET vers /images/ (liste ou autres, mais pas individuelle)
  const isImagesEndpoint = url.includes('/images/') && !url.match(/\/images\/\d+$/) && options.method === 'GET';

  if (isIndividualImage) {
    // Forcer le cache pour les images individuelles
    console.log('Using cached fetch for individual image:', url);
    return originalFetch(resource, {
      ...options,
      cache: 'force-cache'
    });
  } else if (isImagesEndpoint) {
    // Désactiver le cache pour les autres requêtes GET vers /images/ (liste, etc.)
    console.log('Using no-cache fetch for images endpoint:', url);
    return originalFetch(resource, {
      ...options,
      cache: 'no-cache'
    });
  }

  // Pour les autres requêtes, comportement normal
  return originalFetch(resource, options);
};

export {};
//console.log('Cache global configuré pour toutes les images');